import React, {FC} from 'react';

import {Colors} from '@optimaxdev/design-system';
import {Icon, MoneyBackMini} from '@optimaxdev/icons';
import classNames from 'classnames';

import style from './rebateContentCheckout.scss';

export type PropsType = {
    isRebatePassed: boolean;
    maxDiscountRebate: {
        discount: number;
    };
};

/**
 * Rebate content for checkout
 * @returns {JSX.Element} The rendered QuantitySelector component.
 */
export const RebateContentCheckout: FC<PropsType> = ({isRebatePassed, maxDiscountRebate}) => {
    if (!isRebatePassed) return null;

    return (
        <p aria-label="rebate-checkout" className={classNames(style.subscribed, style.rebate)}>
            <Icon
                className={style.moneyBackIcon}
                color={Colors.greenHaze}
                height={16}
                icon={MoneyBackMini}
                strokeWidth={1}
                width={16}
            />
            {`Qualifies for a $${maxDiscountRebate?.discount} rebate`}
        </p>
    );
};
